import { render } from "./Luckybox.vue?vue&type=template&id=03a8f767"
import script from "./Luckybox.vue?vue&type=script&lang=js"
export * from "./Luckybox.vue?vue&type=script&lang=js"
script.render = render

export default script